// packages/web/src/components/learner/LearnerEntryStates.tsx — NUEVO.
// Pantallas de carga y error del link del alumno (fases 'validating', 'starting' y 'error' de LearnerEntry).
// Solo presentación: reciben el mismo título/mensaje que hoy.
import { Loader2 } from 'lucide-react';
import { GuideAvatar, Wordmark } from './ui';

export function LearnerLoading({ title, subtitle }: { title: string; subtitle?: string }) {
  return (
    <main role="status" aria-live="polite" className="min-h-[100dvh] bg-crema font-kid flex flex-col">
      <div className="px-5 pt-6"><Wordmark /></div>
      <div className="flex-1 flex flex-col items-center justify-center gap-4 px-6 text-center">
        <GuideAvatar size={88} />
        <h1 className="text-2xl font-bold text-marzano-600">{title}</h1>
        {subtitle && <p className="text-lg text-slate-700">{subtitle}</p>}
        <Loader2 aria-hidden className="w-7 h-7 text-marzano-600 animate-spin motion-reduce:animate-none" />
      </div>
    </main>
  );
}

/** El mensaje viene de formatEntryError; conviene pasarlo a tú ("Pídele a tu profesora…"). */
export function LearnerError({ message }: { message: string }) {
  return (
    <main className="min-h-[100dvh] bg-crema font-kid flex flex-col">
      <div className="px-5 pt-6"><Wordmark /></div>
      <div className="flex-1 flex flex-col items-center justify-center gap-4 px-6 text-center max-w-md mx-auto">
        <GuideAvatar size={88} />
        <h1 className="text-2xl font-bold text-marzano-600">No pudimos abrir tu evaluación</h1>
        <p role="alert" className="text-lg leading-snug text-slate-800 bg-white rounded-[20px] px-5 py-4">{message}</p>
        <p className="text-base text-slate-600">Avísale a tu profesor o profesora y pídele un link nuevo.</p>
      </div>
    </main>
  );
}
